//Importaciones
import React, { useContext, useEffect, useRef } from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { Card, Col, Row } from 'react-bootstrap';
import { ActionButton, Icon, IconButton, TooltipHost, css, TooltipOverflowMode } from '@fluentui/react';

import './style.css'
import MainAppContext from '../../../../../../MainAppContext';
import i18next from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import ChangeComponentType from '../Dataserie/ChangeComponentType';
import { __enum_ChartDataserieInputType, __enum_PageMode, enum__ComponentType, enum__KPIAgregationTypes, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardChartContainerIdSelected, action_setBoardDataseries, action_setEvents, action_updateBoardFullStructure, action_updateChartSelectedDatapoint, action_updateComponentInfoData, action_updateComponentInfoDataChartCompare, action_updateComponentInfoDataCompare } from '../../../../../../reducers/actions/KPI/actions';
import { updateBoardCompoenet } from '../../../../../../services/sKPI/board.service';
import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import { getLocalStorageValue, isNullUndefined } from '../../../../../../common/Helpers';
import { BOARD_AGGREGATION_WHEN_NULL } from '../../../../../../configurations/application.config';
import SidePanelViewDataserieAditionalInfo from '../../BoardBox/BoardListNew/SidePanelViewDataserieAditionalInfo';
import SidePanelDeleteDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelDeleteDataserieVariableValue';
import SidePanelEditDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelEditDataserieVariableValue';
import SidePanelAddDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelAddDataserieVariableValue';
import SidePanelDataserieClose from '../../BoardElementTypeBox/DataserieClose/SidePanelDataserieClose';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import { useGetUserPropsExternalLanding } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { useGetBoardElementsRoles } from '../../../../../../hooks/services/sKPI/useOfBoard';
import SidePanelViewDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelViewDataserieVariableValue';
import { action_setDefaultSelectedFiltersBinded } from '../../../../../../reducers/actions/SITE/externalHomeActions';
import Loading from '../../../../../Templates/Site/Loading';

function ELEMENT_CONTRACT_HOME_EXTERNAL_KPI_SCOPE(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);
    const dispatch = useDispatch();
    const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);
    const { _boardStructureSpecific: boardStructureSpecific } = useSelector((state) => state.boardViewScope);
    const { _componentInfoData, _componentInfoToCompareData } = useSelector((state) => state.chartDataBoard);
    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);

    const {
        _selectedContract: selectedContract,
		_fireLoading: fireLoading,
    } = useSelector((state) => state.externalHomeScope);
    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);

    const { 
        inputParam_HideHeader = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
        inputParam_ComponentContent = null,
        inputParam_BoardId = null,
        inputParam_ContainerComponent = null,
        inputParam_BoardType = null,
        setBoardVariableDataserieValues = null,
    } = props;

    const [aggregationDataseries, setAggregationDataseries] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_AGGREGATED' + inputParam_BoardId, BOARD_AGGREGATION_WHEN_NULL));
    
    const [isCloseGeneralDataseriesPanelOpen, setIsCloseGeneralDataseriesPanelOpen] = useState(false);

    const [isCloseDataseriesPanelOpen, setIsCloseDataseriesPanelOpen] = useState(false);
    const [isViewDataserieVariableValuePanelOpen, setIsViewDataserieVariableValuePanelOpen] = useState(false);
    const [isAddDataserieVariableValuePanelOpen, setIsAddDataserieVariableValuePanelOpen] = useState(false);
    const [isEditDataserieVariableValuePanelOpen, setIsEditDataserieVariableValuePanelOpen] = useState(false);
    const [isDeleteDataserieVariableValuePanelOpen, setIsDeleteDataserieVariableValuePanelOpen] = useState(false);
    const [isViewDataserieInfoPanelOpen, setIsViewDataserieInfoPanelOpen] = useState(false);
    const [calendarType, setCalendarType] = useState(null);
    const [isViewValidityDataserieChecked, setIsViewValidityDataserieChecked] = useState(false);
    
    const [selectedDataserieToPanel, setSelectedDataserieToPanel] = useState(boardVariableDataserieValues !== null && boardVariableDataserieValues.length > 0 ? boardVariableDataserieValues[0] : null);

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(150, (inputParam_ComponentContent !== null  && inputParam_ComponentContent.items !== null) ? inputParam_ComponentContent.items : []));

    useGetBoardElementsRoles((!isNullUndefined(selectedContract) ? selectedContract.elementId: null), boardElementRoles);
    
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsExternalLanding(inputParam_BoardType, inputParam_BoardId, (!isNullUndefined(selectedContract) ? selectedContract.elementId : null), currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

    const _priv_canCloseDataserie = _checkSecurityUser(contextSite.onlyObserver, userPropsKpi, contextSite.securityProps, (!isNullUndefined(selectedContract) ? selectedContract.elementId: null), enum__PRIVILEGES.KPI_CONTRACT_CLOSE);
    
    const onOpenPanelCloseDataserie = () => {
        setIsCloseGeneralDataseriesPanelOpen(true)
    }

    const onViewValidityDataserie = () => {
        setIsViewValidityDataserieChecked(!isViewValidityDataserieChecked)
    }

    const onOpenPanel = (type, calendarType, dataSerie) => {
        switch (type) {
            case "view":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(true)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "view2":
                setIsViewDataserieVariableValuePanelOpen(true)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "add":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(true)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "edit":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(true)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "delete":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(true)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "close":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(true)
                break;
            default:
                break;
        }

        setSelectedDataserieToPanel(dataSerie)
    
        if (type !== "view") {
            setCalendarType(calendarType)
        }
    };

    const onChangeRowDisplayType = (_type, _component) => {
        let error = false;
        _component.componentTypeId = _type;
        boardStructureSpecific[0].l_structure[0].l_container.forEach(container => {
            container.l_components.forEach(component => {
                if (component.id === _component.id) {
                    component.componentTypeId = _type;
                }
            });
        });

        updateBoardCompoenet(_component, _component.id).then((response) => {  
            if (error === false && response.data.succeeded) { 
                dispatch(action_updateBoardFullStructure(boardStructureSpecific[0].l_structure))
            }
            else {
                //ERROR
            }
        }).catch((e) => {
            error = true;
        });
        
        if (error === false) {        
            dispatch(action_updateBoardFullStructure(boardStructureSpecific[0].l_structure))
        }
    };

    const onChangeRowAggregationTime = (defaultAggregation, elementId, dataserieId) => {
        let calendarFilterStartDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MM/DD/YYYY') : null;

        let calendarFilterEndDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
        
        let calendarFilterSelectorId = contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId;

        getBoardVariableDataSerieValues(inputParam_BoardId, elementId, dataserieId, calendarFilterSelectorId, defaultAggregation ? 2 : 1, calendarFilterStartDate, calendarFilterEndDate).then((response) => {   
            let dataSerieList = boardVariableDataserieValues

            for (let index = 0; index < dataSerieList.length; index++) {
                const dataSerie = dataSerieList[index];

                if(dataSerie.dataserieId === dataserieId) {
                    dataSerie.l_vals = response.data.data[0].l_vals;
                    dispatch(action_setBoardDataseries(dataSerieList));
                }
            }
        }).catch((e) => {

        });
    };

    const onChartDataBindClick = (item, chartDataserieInputType) => {
        switch (chartDataserieInputType) {
            case __enum_ChartDataserieInputType.SINGLE:
                setSelectedDataserieToPanel(item)
                dispatch(action_setBoardChartContainerIdSelected({
                    containerId: inputParam_ContainerComponent.containerId,
                    dataserieId: item.dataserieId
                }));
                dispatch(action_updateChartSelectedDatapoint(null));
                dispatch(action_updateComponentInfoData(item, true));

                onChartDataBindClearCompareClick()
                dispatch(action_setEvents(null));

                let componentTypeName = null
                Object.keys(boardComponentInfoRecursiveValues).forEach(key => {
                    if (boardComponentInfoRecursiveValues[key] !== null) {
                        boardComponentInfoRecursiveValues[key].forEach(componentInfo => {
                            if (componentInfo.componentConfig.id.toString() === inputParam_ContainerComponent.htmlOnclick){
                                componentTypeName = key;
                            }
                        });
                    }
                });

                boardComponentInfoRecursiveValues[componentTypeName].forEach(componentInfo => {
                    if (componentInfo.componentConfig.id.toString() === inputParam_ContainerComponent.htmlOnclick) {
                        componentInfo.componentData.items.forEach(componentItemData => {
                            if (componentItemData.l_dataserie.length > 0) {
                                componentItemData.l_dataserie.forEach(dataserie => {
                                    dataserie.dataSerieId = item.dataserieId;
                                    dataserie.variableName = item.variableName;
    
                                    dataserie.l_vals = item.l_vals;
    
                                    if (dataserie.l_vals.length > 0) {
                                        dataserie.lmax = dataserie.l_vals.reduce((max, current) => {
                                            return current.valueGoalPercent > max ? current.valueGoalPercent : max;
                                        }, dataserie.l_vals[0].valueGoalPercent);
                                    } else {
                                        dataserie.lmax = 0;
                                    }
                                });
                            }
                            else {
                                let aux_item = {...item};

                                aux_item.dataSerieId = item.dataserieId;
                                aux_item.variableName = item.variableName;

                                aux_item.l_vals = item.l_vals;

                                if (aux_item.l_vals.length > 0) {
                                    aux_item.lmax = aux_item.l_vals.reduce((max, current) => {
                                        return current.valueGoalPercent > max ? current.valueGoalPercent : max;
                                    }, aux_item.l_vals[0].valueGoalPercent);
                                } else {
                                    aux_item.lmax = 0;
                                }

                                componentItemData.l_dataserie.push(aux_item);
                            }
                        });
                    }
                });

                break;
            case __enum_ChartDataserieInputType.MULTIPLE:
                dispatch(action_updateComponentInfoDataCompare(item, true))
                break;
            default:
                break;
        }
    }

    const onChartDataBindClearCompareClick = () => {
        dispatch(action_updateComponentInfoDataChartCompare(null, null, false))
    }

    const setterIsDeleteDataserieVariableValuePanelOpen = (value) => {
        setIsDeleteDataserieVariableValuePanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const setterIsEditDataserieVariableValuePanelOpen = (value) => {
        setIsEditDataserieVariableValuePanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const setterIsAddDataserieVariableValuePanelOpen = (value) => {
        setIsAddDataserieVariableValuePanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const setterIsCloseGeneralDataseriesPanelOpen = (value) => {
        setIsCloseGeneralDataseriesPanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const setterIsCloseDataseriesPanelOpen = (value) => {
        setIsCloseDataseriesPanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const setterIsViewDataserieVariableValuePanelOpen = (value) => {
        setIsViewDataserieVariableValuePanelOpen(value);
        dispatch(action_setDefaultSelectedFiltersBinded(false))
    }

    const fieldCount = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field).length

    const renderRow = (item, index) => {
            const fields = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field);
            //let itemComponentStructure = boardVariableDataserieValues.find(x => x.dataserieId === item.dataserieId)
            let itemComponentStructure = item;

            const controlTools =<Col className='col-auto d-flex px-0 px-0 col mx-auto'>
                            <ChangeComponentType
                                inputParam_OnChangeRowDisplayType={onChangeRowDisplayType}
                                inputParam_OnChangeRowAggregationTime={onChangeRowAggregationTime}
                                inputParam_OnOpenPanel={onOpenPanel}
                                inputParam_Component={item}
                                inputParam_ClassName={"p-1 mb-1"}
                                inputParam_ClassNameParent={"col-auto my-auto"}
                                inputParam_DataSerie={itemComponentStructure}
                                inputParam_OnSelectSerieToCompareOnChart={onChartDataBindClick}
                                inputParam_OnChartDataBindClearCompareClick={onChartDataBindClearCompareClick}
                                inputParam_SelectedDataserieToPanel={selectedDataserieToPanel}
                                inputParam_HideAggregationButtons={true}
                                inputParam_BoardType={inputParam_BoardType}
                                inputParam_UserProps={userPropsKpi}
                            />
                    </Col>

            const inputParam_Index = data.data.indexOf(item)
            

            return  <Row data-serie-id={itemComponentStructure.dataserieId} ref={(el) => (scrollersRef.current[index] = el)} onScroll={() => syncScroll(index)} className={`${!itemComponentStructure.active && !isViewValidityDataserieChecked ? "d-none" : ""} d-flex`} style={{height: aggregationDataseries === 1 ? "29px" : undefined, overflow: fieldCount > 5 ? "scroll" : "hidden"}}>
                        <Row className="mx-0 border h-100" style={{width: "100%"}}>
                            <Col className='w-100'>
                                <Col>
                                    <div className='d-flex' style={{left: '-14px', position: 'relative'}}>
                                        <Col style={{width: "19%", height: "100%"}} className={`border-start px-0 h-100 col-auto`}>
                                            {
                                                (inputParam_Index === 0) &&
                                                <div style={{fontSize: "1rem"}} className="border-bottom h-100">
                                                    <Col className="text-center h-100"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-name`) }</b></Col>
                                                </div>
                                            }
                                            <div style={{fontSize: "12px", borderLeft: `10px solid ${!itemComponentStructure.active ? 'red' : ''}`}} className={`my-0 px-1 h-100 pt-1`}>
                                                <TooltipHost content={`${item.variableName} (${item.um})`}>
                                                    <div className='text-start'>
                                                        {`${item.contractual === true ? '(C) ' : ''}${item.variableName} (${item.um})`}
                                                    </div>
                                                </TooltipHost>
                                            </div>
                                        </Col>
                                        {
                                            fields.map((field, index) => (
                                                <Col style={{width: (index === 0) ? "20.5%" : (field === "displayValue" ? "20%" : (field === "valueGoalPercent" ? "14%" : "20%")), height: "100%"}} className={
                                                    `col-auto border-start border-end px-0 ${(fields.length !== index)? "px-0" : "ps-2" }`
                                                    } key={index}>
                                                    {
                                                        (inputParam_Index === 0) &&
                                                        <div style={{fontSize: "1rem"}} className="border-bottom">
                                                            <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-field-${field}`) }</b></Col>
                                                        </div>
                                                    }
                                                    {
                                                        contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.NO_AGG && 
                                                        <>
                                                            {
                                                                item.l_vals.map((val, index) => (
                                                                    <div data-serie-value-id={val.id} style={{fontSize: "12px"}} key={index} className={`${index} h-100 pt-111 ${(index !== item.l_vals.length -1) ? 'border-bottom' : ''} my-0 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                                        {        
                                                                            field === "serieTime" &&
                                                                            <Row className="row p-0 m-0">
                                                                                {
                                                                                    val["hasDocuments"] === true &&
                                                                                    <Col className="col p-0 m-0 col-auto ms-auto"><Icon iconName='TextDocument' styles={{root: {fontSize: "10px !important"}}} title={t('data-lang-lbl-hasdocument')} /></Col>
                                                                                }
                                                                                {
                                                                                    val["hasDocuments"] === false &&
                                                                                    <Col className="col p-0 m-0 col-auto ms-auto"><Icon iconName='OneNoteLogoFill' styles={{root: {fontSize: "10px !important"}}} /></Col>
                                                                                }
                                                                                <Col className="col p-0 m-0 my-auto">{val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}</Col>
                                                                            </Row>
                                                                        }
                                                                        {
                                                                            field !== "serieTime" &&
                                                                            <Row className="row p-0 m-0">
                                                                                <Col className="col p-0 m-0 my-auto">
                                                                                    {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18next.language) : val[field])  : t('no-data')}`}
                                                                                    {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                                </Col>
                                                                            </Row>
                                                                        }
                                                                    </div>
                                                                ))
                                                            }
                                                            {
                                                                item.l_vals.length === 0 && 
                                                                    <div style={{fontSize: "12px"}} className={`my-0 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === enum__KPIAgregationTypes.DF_AGG && 
                                                        <>
                                                            {
                                                                item.l_agg_vals.map((val, index) => (
                                                                    <div style={{fontSize: "12px"}} key={index} className={`${index} h-100 pt-111 ${(index !== item.l_agg_vals.length -1) ? 'border-bottom' : ''} my-0 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                                                                        {          
                                                                            field === "serieTime" &&
                                                                            <>
                                                                                {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                                                            </>
                                                                        }
                                                                        {
                                                                            field !== "serieTime" &&
                                                                            <>
                                                                                {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18next.language) : val[field])  : t('no-data')}`}
                                                                                {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                                                            </>
                                                                        }
                                                                    </div>
                                                                ))
                                                            }
                                                            {
                                                                item.l_agg_vals.length === 0 && 
                                                                    <div style={{fontSize: "12px"}} className={`my-0 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                            ))
                                        }
                                        <Col className={`col-auto ms-3 ${inputParam_Index === 0 ? 'mt-3' : ''}`} style={{ backgroundColor: 'white', zIndex: '1' }}>
                                            <Row>
                                                { controlTools }
                                            </Row>
                                        </Col>
                                    </div>
                                </Col>
                            </Col>
                        </Row>
                    </Row>
    }

    const syncScroll = (sourceIndex) => {
        if (preventEvent.current) {
            preventEvent.current = false;
            return;
        }

        preventEvent.current = true;

        const newLeft = scrollersRef.current[sourceIndex]?.scrollLeft || 0;

        scrollersRef.current.forEach((ref, idx) => {
            if (idx !== sourceIndex && ref) {
                ref.scrollLeft = newLeft;
            }
        });
    };

    const scrollersRef = useRef([]);
    const preventEvent = useRef(false);
    useEffect(() => {
        scrollersRef.current = scrollersRef.current.slice(0, fieldCount);
    }, [fieldCount]);

    //Render de componente.
    return (
        <Card className='h-100'>
            {
                !inputParam_HideHeader &&
                <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <TooltipHost
                        overflowMode={TooltipOverflowMode.Self}
                        hostClassName={css({
                            overflow: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            },
                        })}
                        onTooltipToggle={false}
                        styles={{
                            root: { display: 'flex', width: "85%" },
                        }}
                        content={selectedContract !== null && (selectedContract.supplierName !== null && selectedContract.contractCode !== null) ? `${selectedContract.supplierName} - ${selectedContract.supplierName}` : t('data-lang-lbl-kpiscope')}>
                        <div style={{ width: '90%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <b>{ selectedContract !== null && (selectedContract.supplierName !== null && selectedContract.contractCode !== null) ? `${selectedContract.contractCode} - ${selectedContract.supplierName}` : t('data-lang-lbl-kpiscope')}</b>
                        </div>
                    </TooltipHost>
                    <div className='toolbar d-flex'>
                        {
                            (_priv_canCloseDataserie.value && _priv_canCloseDataserie.mode === __enum_PageMode.Edit) &&
                            <ActionButton iconProps={{iconName: 'Lock12'}} text={t('data-lang-btn-closedataseries')} onClick={onOpenPanelCloseDataserie} />
                        }
                        <ActionButton iconProps={{iconName: 'Lock12'}} text={isViewValidityDataserieChecked ? t('data-lang-btn-hidevalidity') : t('data-lang-btn-viewvalidity')} onClick={onViewValidityDataserie} />
                    </div>
                </Card.Title>
            </Card.Header>
            }
            <Card.Body className='p-0 h-100' style={{overflowY: "scroll", overflowX: "hidden"}}>
                {
                    fireLoading === false &&
                    <Row className='text-center px-1'>
                        {
                            !isNullUndefined(selectedContract) &&
                            <Col>
                            {
                                !isNullUndefined(userPropsKpi.hasAccess) && boardElementRoles && data.data !== null &&
                                data.data.map((x, index) =>
                                    renderRow(x, index)
                                )
                            }
                            </Col>
                        }
                        {
                            isNullUndefined(selectedContract) &&
                            <Col>
                                {t('data-lang-lbl-selectcontract')}
                            </Col>
                        }
                    </Row>
                }
                {
                    fireLoading === true &&
                    <Loading
						inputParam_Style={{marginTop: 100}}
                        inputParam_Width = '30px'
                        inputParam_Height = '30px'
                    />
                }
            </Card.Body>
            {
                selectedContract && selectedDataserieToPanel !== null && calendarType !== null &&
                <>
                    <SidePanelViewDataserieVariableValue
                        inputParam_ElementId={selectedContract.elementId}
                        inputParam_SetterIsPanelOpen={setterIsViewDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isViewDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_UserProps={userPropsKpi}
                    />
                    <SidePanelAddDataserieVariableValue
                        inputParam_ElementId={selectedContract.elementId}
                        inputParam_SetterIsPanelOpen={setterIsAddDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isAddDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_UserProps={userPropsKpi}
                    />
                    <SidePanelEditDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setterIsEditDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isEditDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_UserProps={userPropsKpi}
                        //[#NEW#]
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_ElementId={selectedContract.elementId}
                    />
                    <SidePanelDeleteDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setterIsDeleteDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isDeleteDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_UserProps={userPropsKpi}
                    />
                </> 
            }
            {
                selectedContract && isCloseGeneralDataseriesPanelOpen &&
                <SidePanelDataserieClose
                    inputParam_BoardId={inputParam_BoardId}
                    inputParam_ElementId={(boardVariableDataserieValues && boardVariableDataserieValues.length > 0) ? selectedContract.elementId : null }
                    inputParam_DataSerieList={boardVariableDataserieValues}
                    inputParam_IsPanelOpen={isCloseGeneralDataseriesPanelOpen}
                    inputParam_SetterIsPanelOpen={setterIsCloseGeneralDataseriesPanelOpen}
                />
            }
            {
                selectedContract && selectedDataserieToPanel !== null && isCloseDataseriesPanelOpen &&
                <SidePanelDataserieClose
                    inputParam_BoardId={inputParam_BoardId}
                    inputParam_ElementId={selectedContract.elementId}
                    inputParam_DataSerieList={[selectedDataserieToPanel]}
                    inputParam_IsPanelOpen={isCloseDataseriesPanelOpen}
                    inputParam_SetterIsPanelOpen={setterIsCloseDataseriesPanelOpen}
                />
            }
            {
                selectedDataserieToPanel !== null && isViewDataserieInfoPanelOpen &&
                <SidePanelViewDataserieAditionalInfo
                    inputParam_SetterIsPanelOpen={setIsViewDataserieInfoPanelOpen}
                    inputParam_IsPanelOpen={isViewDataserieInfoPanelOpen}
                    inputParam_DataSerie={selectedDataserieToPanel}
                    inputParam_SetterDataSerie={setSelectedDataserieToPanel}
                    inputParam_BoardId={inputParam_BoardId}
                    inputParam_UserProps={userPropsKpi}
                />
            }
        </Card>    
    );
}

export default ELEMENT_CONTRACT_HOME_EXTERNAL_KPI_SCOPE;